// extracted by mini-css-extract-plugin
export var compactFilters = "_fx-4";
export var detailImage = "_fx-1";
export var dropdownContainer = "_fx-2";
export var imageContainer = "_fx-0";
export var selectedCard = "_fx-3";